import Title from "@components/common/Title";
import {
  CardWrapperDynamicZoneModel,
  CardWrapperVariant,
} from "@models/strapi-components/card-wrapper";
import React from "react";
import Cards from "./Card";
import { motion } from "framer-motion";
import Link from "@components/common/Link";
export interface CardWrapperPropsModel {
  componentData: CardWrapperDynamicZoneModel;
}

const variantBasedClassName: Record<
  CardWrapperVariant,
  Record<string, string>
> = {
  [CardWrapperVariant.BASE]: {
    cardWrapperClassName:
      "flex flex-col sm:flex-row gap-8 sm:gap-10 items-center sm:items-stretch justify-center py-4 md:px-24 xl:px-8 h-full mt-8",
  },
  [CardWrapperVariant.INTEGRATION]: {
    cardWrapperClassName: "flex gap-4 justify-center flex-wrap p-4 mt-8",
  },
};

const CardWrapper: React.FunctionComponent<CardWrapperPropsModel> = ({
  componentData,
}) => {
  const {
    title,
    subTitle,
    bgColor,
    variant = CardWrapperVariant.BASE,
    cards,
    learnMoreLink,
    learnMoreText,
  } = componentData;
  const { cardWrapperClassName } = variantBasedClassName[variant];
  return (
    <div
      style={{ backgroundColor: bgColor ?? "#FFFFFF" }}
      className="px-8 py-12 md:py-[60px] xl:py-20 "
    >
      <div className="">
        <Title
          variant="h2"
          titleText={title}
          className="text-center md:max-w-[42%] mx-auto"
        />
        <Title
          variant="paragraph"
          titleText={subTitle}
          className="text-center sm:max-w-[44%] md:max-w-[47%] mx-auto"
        />
        {learnMoreLink && learnMoreLink ? (
          <Link
            href={learnMoreLink}
            linkText=""
            wrapperClassName="mx-auto flex justify-center mt-1"
            className="text-center max-w-fit block"
          >
            {learnMoreText}
          </Link>
        ) : (
          <></>
        )}
      </div>

      <div className={cardWrapperClassName}>
        {cards?.map((cardData) => (
          <motion.div key={cardData.id}>
            <Cards cardData={cardData} variant={variant} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CardWrapper;
